import { Icon } from '@fluentui/react';
import { useTheme } from '@h2oai/ui-kit';
import { useEffect, useState } from 'react';

import { FwIpRequest, FwPortRequest } from '../../admin-center/gen/fw_management/fw_management_pb';
import { useAdminCenterService } from '../../admin-center/hooks';
import {
  anchorStyles,
  fwTableOptionStyles,
  fwTypeAreaStyle,
  sidePanelStyle,
  tableAreaStyle,
  tableStyle,
  tableWrapper,
  titleAreaStyle,
  titleStyle,
} from './components/FWManagement/FWManagement.styles';
import IPSidePanel from './components/FWManagement/IPTable/IPSidePanel';
import IPTable from './components/FWManagement/IPTable/IPTable';
import PortSidePanel from './components/FWManagement/PortTable/PortSidePanel';
import PortTable from './components/FWManagement/PortTable/PortTable';
import PageWrapper from './PageWrapper';

export default function FWManagement() {
  const [isIPPanelOpen, setIPPanelOpen] = useState(false);
  const [isPortPanelOpen, setPortPanelOpen] = useState(false);
  const [fwIps, setFwIps] = useState<string[]>([]);
  const [fwPorts, setFwPorts] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const service = useAdminCenterService();
  const theme = useTheme();

  const handleAddIPButtonClick = () => {
    setIPPanelOpen(true);
  };
  const handleAddPortButtonClick = () => {
    setPortPanelOpen(true);
  };
  const FetchFwData = async () => {
    setIsLoading(true);
    try {
      const ipReq: FwIpRequest = {};
      const portRequest: FwPortRequest = {};
      const ipResponse = await service.getFwIps(ipReq);
      const portResponse = await service.getFwPorts(portRequest);
      const ips = ipResponse.fwIps || [];
      const ports = portResponse.fwPorts || [];

      setFwIps(ips);
      setFwPorts(ports);
    } catch (error) {
      console.error('Error fetching FW data:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    FetchFwData();
  }, []);

  return (
    <PageWrapper>
      <div style={tableWrapper}>
        <div style={fwTypeAreaStyle}>
          <div style={titleAreaStyle}>
            <h2 style={titleStyle}>Inbound IPs</h2>
            <a
              href="https://docs.h2o.ai/mc-admin-center/guide/environment-management/firewall-management#add-inbound-ips"
              style={anchorStyles(theme)}
              target="_blank"
              rel="noreferrer"
            >
              <Icon iconName="SurveyQuestions" style={{ margin: '0 4px' }} />
            </a>
          </div>

          <div style={tableAreaStyle}>
            <div style={fwTableOptionStyles}>
              {isIPPanelOpen && (
                <div style={sidePanelStyle}>
                  <IPSidePanel isOpen={isIPPanelOpen} setOpen={setIPPanelOpen} onSubmitSuccess={FetchFwData} />
                </div>
              )}
            </div>
            <div style={tableStyle}>
              <IPTable
                fwIps={fwIps}
                onSubmitSuccess={FetchFwData}
                isLoading={isLoading}
                onAddButtonClick={handleAddIPButtonClick}
              />
            </div>
          </div>
        </div>

        <div style={fwTypeAreaStyle}>
          <div style={titleAreaStyle}>
            <h2 style={titleStyle}>Outbound Ports</h2>
            <a
              href="https://docs.h2o.ai/mc-admin-center/guide/environment-management/firewall-management#add-outbound-ports"
              style={anchorStyles(theme)}
              target="_blank"
              rel="noreferrer"
            >
              <Icon iconName="SurveyQuestions" style={{ margin: '0 4px' }} />
            </a>
          </div>

          <div style={tableAreaStyle}>
            <div style={fwTableOptionStyles}>
              {isPortPanelOpen && (
                <div style={sidePanelStyle}>
                  <PortSidePanel isOpen={isPortPanelOpen} setOpen={setPortPanelOpen} onSubmitSuccess={FetchFwData} />
                </div>
              )}
            </div>
            <div style={tableStyle}>
              <PortTable
                fwPorts={fwPorts}
                onSubmitSuccess={FetchFwData}
                isLoading={isLoading}
                onAddButtonClick={handleAddPortButtonClick}
              />
            </div>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
}
